import { c as _c } from "react/compiler-runtime";
import React from "react";
// import React, { useEffect, useState } from "react";
// import { Category } from "./ResourceGrid";
import { ResourceGridDropdown } from "../ResourceGridDropdown/ResourceGridDropdown";
import { Chip } from "@/components/terra/component/Chip/Chip";
// import { title } from "process";

export interface FilterOption {
  title: string;
  id: string;
  category?: FilterOption;
}
interface BlogFiltersProps {
  gridFilters?: any;
  selectedFilters: FilterOption[] | [];
  selectedSorting: FilterOption[];
  sortingOptions: string[];
  labelSortBy?: string;
  labelClearAll?: string;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  handleFilterChange: Function;
  handleSortingChange: (selected: FilterOption[]) => void;
  handleChipDelete: (filter: FilterOption) => void;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  setSelectedSorting: Function;
}
const BlogFilters = t0 => {
  const $ = _c(23);
  const {
    gridFilters,
    selectedFilters,
    selectedSorting,
    sortingOptions,
    labelSortBy: t1,
    labelClearAll: t2,
    handleChipDelete,
    handleFilterChange,
    handleSortingChange
  } = t0;
  const labelSortBy = t1 === undefined ? "Sort By" : t1;
  const labelClearAll = t2 === undefined ? "Clear All" : t2;
  let t3;
  if ($[0] !== gridFilters?.filterTags || $[1] !== handleFilterChange || $[2] !== labelClearAll || $[3] !== selectedFilters) {
    t3 = gridFilters?.filterTags?.map((filter, index) => <ResourceGridDropdown key={`${filter?.title}-${index}`} options={filter?.dropdownValues?.map(value => ({
      id: value.id,
      title: value.label,
      category: {
        title: filter?.title,
        id: filter?.id
      }
    }))} title={filter?.title} selectedFilters={selectedFilters} onChange={handleFilterChange} multiSelect={true} labelClearAll={labelClearAll} />);
    $[0] = gridFilters?.filterTags;
    $[1] = handleFilterChange;
    $[2] = labelClearAll;
    $[3] = selectedFilters;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== sortingOptions) {
    t4 = sortingOptions?.map(_temp);
    $[5] = sortingOptions;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== handleSortingChange || $[8] !== labelSortBy || $[9] !== selectedSorting || $[10] !== t4) {
    t5 = <ResourceGridDropdown key="sort" options={t4} onChange={handleSortingChange} selectedFilters={selectedSorting} title={labelSortBy} multiSelect={false} />;
    $[7] = handleSortingChange;
    $[8] = labelSortBy;
    $[9] = selectedSorting;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t3 || $[13] !== t5) {
    t6 = <div className="flex flex-wrap text-gray-m9 text-base font-normal leading-6 tracking-[0.16px] capitalize gap-5 max-[1200px]:w-full">{t3}{t5}</div>;
    $[12] = t3;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== handleChipDelete || $[16] !== selectedFilters) {
    t7 = selectedFilters && selectedFilters?.map((filter_0, i) => <Chip key={`${filter_0?.id}-${i}`} label={filter_0?.title} isIcon={true} onDelete={() => handleChipDelete(filter_0)} />);
    $[15] = handleChipDelete;
    $[16] = selectedFilters;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t7) {
    t8 = <div className="flex flex-wrap gap-2.5 max-[1200px]:w-full">{t7}</div>;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t6 || $[21] !== t8) {
    t9 = <div className="flex justify-between flex-wrap items-start mb-[70px] gap-5">{t6}{t8}</div>;
    $[20] = t6;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
};
export default BlogFilters;
function _temp(opt) {
  return {
    id: opt,
    title: opt
  };
}